import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconArtist } from "../../assets/images/icon-artist.svg";
import { ReactComponent as IconCaretDown } from "../../assets/images/icon-caret-down.svg";
import { ReactComponent as IconCheck } from "../../assets/images/icon-check.svg";
import { ReactComponent as IconCheckCircle } from "../../assets/images/icon-check-circle.svg";
import { ReactComponent as IconError } from "../../assets/images/icon-error.svg";
import { ReactComponent as IconErrorCircle } from "../../assets/images/icon-error-circle.svg";
import { ReactComponent as IconFacebook } from "../../assets/images/icon-facebook.svg";
import { ReactComponent as IconHeart } from "../../assets/images/icon-heart.svg";
import { ReactComponent as IconInstagram } from "../../assets/images/icon-instagram.svg";
import { ReactComponent as IconLogo } from "../../assets/images/logo.svg";
import { ReactComponent as IconMenu } from "../../assets/images/icon-menu.svg";
import { ReactComponent as IconProfile } from "../../assets/images/icon-profile.svg";
import { ReactComponent as IconTwitter } from "../../assets/images/icon-twitter.svg";
import { ReactComponent as IconVisibilityOff } from "../../assets/images/icon-visibility-off.svg";
import { ReactComponent as IconVisibilityOn } from "../../assets/images/icon-visibility-on.svg";
import { ReactComponent as IconWebsite } from "../../assets/images/icon-website.svg";
import { ReactComponent as IconYoutube } from "../../assets/images/icon-youtube.svg";

const iconTypes = {
  'caret-down': IconCaretDown,
  'check-circle': IconCheckCircle,
  'error-circle': IconErrorCircle,
  'visibility-off': IconVisibilityOff,
  'visibility-on': IconVisibilityOn,
  artist: IconArtist,
  check: IconCheck,
  error: IconError,
  facebook: IconFacebook,
  heart: IconHeart,
  instagram: IconInstagram,
  logo: IconLogo,
  menu: IconMenu,
  profile: IconProfile,
  twitter: IconTwitter,
  website: IconWebsite,
  youtube: IconYoutube,
};

const AppIcon = ({ name, ...props }) => {
  const TheIcon = iconTypes[name];

  if (!TheIcon) { return }
  return <TheIcon {...props} />;
};

AppIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(iconTypes)).isRequired,
};

export default AppIcon;